import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getStartupVerifiedIcon } from 'utils/functions';
import { PlusCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATH, ROUTE_STARTUP_PATH } from 'routes';
import BaseSelect from './BaseSelect';

function StartupsSelect({ platform, startup, offset }) {
  const user = useSelector(state => state.session.user);
  const literals = useSelector(state => state.i18n.literals.startupsSelect);
  const navigate = useNavigate();

  return (
    <BaseSelect
      platform={platform}
      item={startup}
      offset={offset}
      items={user.startups}
      renderVerifiedIcon={getStartupVerifiedIcon}
      onChange={(v) => navigate(ROUTE_STARTUP_PATH.setHome(v))}
      actions={[
        {
          text: literals.addCompany,
          icon: PlusCircle,
          onClick: () => navigate(ROUTE_PATH.PREHOME),
        },
      ]}
      text={literals.company}
    />
  );
}

StartupsSelect.propTypes = {
  platform: PropTypes.object.isRequired,
  startup: PropTypes.object,
  offset: PropTypes.object,
};

export default StartupsSelect;
